import { ListChecks } from '@phosphor-icons/react';

export default ListChecks;